import Link from "next/link";
import { CircularDiv, CustomDiv, InlineDiv } from "@/common/divs";
import { RegularText, SemiBoldText } from "@/common/texts";
import { BlogCardProps } from "@/types/components";
import {
  NEUTRO_TITLES_COLOR,
  PRIMARY_BUTTON_COLOR,
  SECONDARY_BUTTON_COLOR,
} from "@/utils/constants";

const BlogCard: React.FC<BlogCardProps> = ({
  imageUrl,
  title,
  width,
  height,
  tag,
  description,
  link,
}) => {
  return (
    <CustomDiv
      className="background-with-image-landing"
      width={width ? width : "291px"}
      height={height ? height : "291px"}
      style={{
        backgroundImage:
          "linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9)), url(" +
          imageUrl +
          ")",
        minWidth: width ? width : "291px",
      }}
    >
      <Link
        href={link}
        style={{ display: "grid", height: "auto" }}
        target={"_blank"}
      >
        <div className="blog-cards-landing">
          <CircularDiv
            background={PRIMARY_BUTTON_COLOR}
            height="32px"
            paddingX="16px"
            width="fit-content"
          >
            <SemiBoldText
              fontSize="14px"
              color={NEUTRO_TITLES_COLOR}
              style={{ marginTop: "-4px" }}
            >
              {tag}
            </SemiBoldText>
          </CircularDiv>
          <div
            style={{
              marginTop: "8px",
              width: width ? "calc(" + width + " - 20px)" : "270px",
            }}
          >
            <SemiBoldText
              className="text-overflow-blog"
              fontSize="20px"
              color={SECONDARY_BUTTON_COLOR}
            >
              {title}
            </SemiBoldText>
          </div>
          <InlineDiv
            style={{
              marginTop: "0px",
            }}
          >
            <RegularText
              className="overflowOnTwoLines"
              fontSize="14px"
              color={SECONDARY_BUTTON_COLOR}
            >
              {description}
            </RegularText>
          </InlineDiv>
        </div>
      </Link>
    </CustomDiv>
  );
};

export default BlogCard;
